import {
  apiClient,
  ApiClientConfig,
  PaginatedRequestParams,
  PaginatedResponse,
} from "api";
import {
  UserWithWallet,
  WalletTransactionDetails,
  WalletTransactionsHistoryItem,
} from "types";

export type UsersWithWalletResponse = PaginatedResponse<UserWithWallet>;

export type UsersWithWalletParams = {
  phone_number?: string;
  amount?: string;
  transaction_amount_from?: string | number;
  transaction_amount_to?: string | number;
  user_name?: string;
  auth?: string;
  tranid?: string;
  refrence_no?: string;
  status_id?: string;
  from_date?: string;
  to_date?: string;
  transaction_From_Date?: string;
  transaction_To_Date?: string;
  adminuser?: string;
} & PaginatedRequestParams;

export type WalletTransactionsHistoryResponse = {
  wallet_owner: string;
} & PaginatedResponse<WalletTransactionsHistoryItem>;

export type TopUpWalletDTO = {
  wallet_id: string;
};
export type CreateApprovedDTO = {
  WithdrawRequestIds: string[];
  CreatedBy: string;
  LoginUserName: string;
  Remark?: string;
  ActionType: number;
  IsAll?: boolean;
  RefrenceNumber?: string;
  RoleType?: string;
};
export type CreateRejectDTO = {
  question?: string;
  OptionList?: any;
};

export type deductWalletDTO = {
  wallet_id: string;
  amount: number;
  currency: string;
};
export type AmountFilterConfigResponse = {
  min_amount: number;
  max_amount: number;
  range_interval: number;
};

export const WithdrawApiService = () => {
  const getUsersWithWithdraw = async (
    params: UsersWithWalletParams,
    callConfig?: Partial<ApiClientConfig>
  ) => {
    const response = await apiClient<UsersWithWalletResponse>({
      ...callConfig,
      endpoint: `/admin/withdraw/withdrawList`,
      params,
    });

    return response.data;
  };
  const getWithdrawTransactionDetails = async (
    id: string,
    callConfig?: Partial<ApiClientConfig>
  ) => {
    const response = await apiClient<WalletTransactionDetails>({
      ...callConfig,
      endpoint: `admin/withdraw/withdrawList?${id}&adminuser=accountant`,
    });

    return response.data;
  };

  const getSuperAdminTransactionDetails = async (
    id: string,
    callConfig?: Partial<ApiClientConfig>
  ) => {
    const response = await apiClient<WalletTransactionDetails>({
      ...callConfig,
      endpoint: `admin/withdraw/withdrawList?${id}&adminuser=superadmin`,
    });

    return response.data;
  };
  const createApproved = async (payload: CreateApprovedDTO) => {
    const response = await apiClient({
      endpoint: `admin/withdraw/ApproveNReject`,
      method: "POST",
      data: payload,
    });

    return response.data;
  };
  const createReject = async (payload: CreateApprovedDTO) => {
    const response = await apiClient({
      endpoint: `admin/withdraw/ApproveNReject`,
      method: "POST",
      data: payload,
    });

    return response.data;
  };
  const createSuperAdminReject = async (payload: CreateApprovedDTO) => {
    const response = await apiClient({
      endpoint: `admin/withdraw/SuperAdminApproveNReject`,
      method: "POST",
      data: payload,
    });

    return response.data;
  };
  const createSuperAdminManualApi = async (payload: CreateApprovedDTO) => {
    const response = await apiClient({
      endpoint: `admin/withdraw/SuperAdminApproveNReject/Forcefully`,
      method: "POST",
      data: payload,
    });

    return response.data;
  };

  const SuperAdminManualApi = async (payload: CreateApprovedDTO) => {
    const response = await apiClient({
      endpoint: `admin/withdraw/superadminapprovemultiplewithdraw/bulkapproved`,
      method: "POST",
      data: payload,
    });

    return response.data;
  };
  const getAmountFilterConfig = async (
    callConfig?: Partial<ApiClientConfig>
  ) => {
    const response = await apiClient<AmountFilterConfigResponse>({
      ...callConfig,
      endpoint: `/admin/withdraw/amountfilterconfig`,
    });

    return response.data;
  };

  return {
    getUsersWithWithdraw,
    createApproved,
    createReject,
    getWithdrawTransactionDetails,
    getSuperAdminTransactionDetails,
    createSuperAdminReject,
    createSuperAdminManualApi,
    SuperAdminManualApi,
    getAmountFilterConfig,
  };
};
